import { isEmpty } from "lodash";
import { AddressBook } from "./AddressBook";
import { Carrier } from "./Carrier";
import { CarrierConfiguration } from "./CarrierConfiguration";
import { Company } from "./Company";
import { getDictionary } from "../utilities/utilities";
import { Validate } from "./Validate";
import moment from "moment";

const dictionary = getDictionary();

export interface Collection {
  id: string;
  creationDate: string;
  creationUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  ownerId: string;
  owner: Company;
  internalReference: string;
  externalReference: string;
  carrierReference: string;
  date: Date;
  morningOpenTime: string;
  morningCloseTime: string;
  afternoonOpenTime: string;
  afternoonCloseTime: string;
  status: string;
  addressBook: AddressBook;
  addressBookId: string;
  carrier: Carrier;
  carrierConfiguration: CarrierConfiguration;
  totalWeight: number;
  numPackages: number;
}

export interface CreateCollection {
  ownerId: string;
  externalReference?: string;
  date: Date;
  morningOpenTime: string;
  morningCloseTime: string;
  afternoonOpenTime: string;
  afternoonCloseTime: string;
  addressBookId: string;
  carrierCode: string;
  carrierConfigurationId: string;
  totalWeight: number;
  numPackages: number;
}

export interface UpdateCollection extends CreateCollection {
  id: string;
}

const convertedCollection = (collection: Collection) => ({
  ownerId: collection.ownerId,
  externalReference: collection.externalReference,
  date: collection.date,
  morningOpenTime: collection.morningOpenTime,
  morningCloseTime: collection.morningCloseTime,
  afternoonOpenTime: collection.afternoonOpenTime,
  afternoonCloseTime: collection.afternoonCloseTime,
  addressBookId: collection.addressBookId,
  carrierCode: collection.carrierConfiguration.carrierCode,
  carrierConfigurationId: collection.carrierConfiguration.id,
  totalWeight: collection.totalWeight,
  numPackages: collection.numPackages,
});

export const convertCollectionToCreate = (
  collection: Collection
): CreateCollection => {
  return {
    ...convertedCollection(collection),
  };
};

export const convertCollectionToUpdate = (
  collection: Collection
): UpdateCollection => {
  return {
    id: collection.id,
    ...convertedCollection(collection),
  };
};

export const defaultCollection: Partial<CreateCollection> = {
  // date: moment().toDate(),
  morningOpenTime: moment("09:00", "HH:mm").format("HH:mm"),
  morningCloseTime: moment("13:00", "HH:mm").format("HH:mm"),
  afternoonOpenTime: moment("14:00", "HH:mm").format("HH:mm"),
  afternoonCloseTime: moment("18:00", "HH:mm").format("HH:mm"),
  numPackages: 1,
  totalWeight: 1.0,
};

export const validate = (
  collection: Collection,
  standAlone: boolean
): Validate => {
  const validate: Validate = { isValid: true, errors: {} };

  if (standAlone && !collection.carrierConfiguration) {
    validate.errors.carrierConfiguration = dictionary.messages.mandatory_field;
  }

  if (!collection.date) {
    validate.errors.date = dictionary.messages.mandatory_field;
  }

  if (!collection.numPackages) {
    validate.errors.numPackages = dictionary.messages.mandatory_field;
  }

  if (!collection.totalWeight) {
    validate.errors.totalWeight = dictionary.messages.mandatory_field;
  }

  if (!collection.morningOpenTime) {
    validate.errors.morningOpenTime = dictionary.messages.mandatory_field;
  }

  if (!collection.morningCloseTime) {
    validate.errors.morningCloseTime = dictionary.messages.mandatory_field;
  }

  if (
    moment(collection.morningOpenTime).isAfter(
      moment(collection.morningCloseTime)
    )
  ) {
    validate.errors.morningCloseTime =
      dictionary.messages.it_must_be_next_to +
      " " +
      moment(collection.morningOpenTime).format("HH:mm");
  }

  if (!collection.afternoonOpenTime) {
    validate.errors.afternoonOpenTime = dictionary.messages.mandatory_field;
  }

  if (!collection.afternoonCloseTime) {
    validate.errors.afternoonCloseTime = dictionary.messages.mandatory_field;
  }

  if (
    moment(collection.afternoonOpenTime).isAfter(
      moment(collection.afternoonCloseTime)
    )
  ) {
    validate.errors.afternoonCloseTime =
      dictionary.messages.it_must_be_next_to +
      " " +
      moment(collection.afternoonOpenTime).format("HH:mm");
  }

  if (!collection.addressBookId) {
    validate.errors.addressBookId = dictionary.messages.mandatory_field;
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }

  return validate;
};
